import { useCallback } from 'react';
import { VALID_GAME_ID } from '@root/constants';
import { useStomp } from '@root/providers';
import { useActions } from '@root/store/store';
import { v4 as uuidv4 } from 'uuid';

// Resume and abandon for a paused run. Both are fire-and-forget: the answer
// comes back as a funding status on /game/notification, not as a reply.
export function useRunControls() {
  const { emitMessage } = useStomp();
  const actions = useActions();

  const resume = useCallback(() => {
    const sent = emitMessage('/app/game/run/resume', {
      gameId: VALID_GAME_ID,
      requestId: uuidv4(),
    });
    // Hold the button until the server answers, so it can't be sent twice.
    if (sent) actions.setResuming(true);
    return sent;
  }, [emitMessage, actions]);

  const abandon = useCallback(
    () =>
      emitMessage('/app/game/run/abandon', {
        gameId: VALID_GAME_ID,
        requestId: uuidv4(),
      }),
    [emitMessage]
  );

  return { resume, abandon };
}
